import URL from './urlHelper';

export default function (...argument: any) {
  return new URL(...argument);
}
